import { normalizeOrganizedTourSearchResult } from "../../../utils/normalizeOrganizedTourSearchResult";
import { extractOrgTourDepartureDate } from "../utils/orgTourDepartureDateFilter";
import { extractOrgTourDestinationChip } from "../utils/orgTourDestinationFilter";
import { extractOrgTourCountryChip } from "../utils/orgTourCountryFilter";

/**
 * Single SSOT mapping: raw LDS search row → card VM + filter primitives.
 * Runs `normalizeOrganizedTourSearchResult` once per deal (no duplicate normalize in cards).
 */
export function mapLdsDealToCardVm(deal) {
  const normalized = normalizeOrganizedTourSearchResult(deal);
  const root = normalized.dealRoot || deal?.fullDeal || deal;
  const price = parseInt(
    String(root?.dealFare?.totalFare ?? deal?.dealFare?.totalFare ?? 0),
    10
  );
  const stars = parseInt(String(root?.hotel?.category || "").replace(/\D/g, ""), 10);
  const dep = extractOrgTourDepartureDate(deal);
  const destChip = extractOrgTourDestinationChip(normalized);
  const countryChip = extractOrgTourCountryChip(normalized);
  return {
    ...normalized,
    raw: normalized.raw,
    _finalPriceILS: Number.isFinite(price) ? price : 0,
    _stars: Number.isFinite(stars) ? stars : null,
    _board: root?.hotel?.board || deal?.fullDeal?.hotel?.board || "",
    _destinationChipKey: destChip?.key ?? null,
    _destinationChipLabel: destChip?.label ?? null,
    _hotelNameNormalized: destChip?.key ?? "",
    _departureDateKey: dep?.key ?? null,
    _countryChipKey: countryChip?.key ?? null,
  };
}

/**
 * Flat list of organized-tour deals from heterogeneous search payloads.
 */
export function extractOrganizedTourDealRows(searchResults) {
  if (!Array.isArray(searchResults)) return [];
  return searchResults.filter((row) => {
    const dt =
      row?.dealType ||
      row?.fullDeal?.dealType ||
      row?.fullDeal?.dealtype ||
      "";
    return String(dt) === "OrganizedTour";
  });
}
